document.addEventListener('DOMContentLoaded', function () {
  /* --- Quick View Logic --- */
  const modal = document.getElementById('QuickViewModal');
  const track = document.getElementById('QVGalleryTrack');
  const info = document.getElementById('QVInfo');
  const closeBtn = modal?.querySelector('.quick-view-modal__close');
  const overlay = modal?.querySelector('.quick-view-modal__overlay');
  
  const fullModal = document.getElementById('FullGalleryModal');
  const fullImage = document.getElementById('FullGalleryImage');
  const fullClose = fullModal?.querySelector('.full-gallery-close');

  let currentProductData = null;
  let currentImageIndex = 0;

  // Helper for formatting money if global function is missing
  const safeFormatMoney = (cents) => {
    if (window.formatMoney) return window.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  };

  // Get root URL safely
  const rootUrl = window.Shopify?.routes?.root_url || '/';
  const cleanRootUrl = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';

  function openQuickView(handle, btn) {
    if (!handle) return;
    if (btn) btn.classList.add('is-loading');
    
    fetch(`${cleanRootUrl}products/${handle}.js`)
      .then(res => {
        if (!res.ok) throw new Error('Product not found');
        return res.json();
      })
      .then(product => {
        currentProductData = product;
        renderQuickView();
        if (modal) {
          modal.classList.add('is-active');
        }
        document.body.style.overflow = 'hidden';
      })
      .catch(err => {
        console.error('Quick View Error:', err);
      })
      .finally(() => {
        if (btn) btn.classList.remove('is-loading');
      });
  }

  function renderQuickView() {
    if (!currentProductData || !track || !info) return;
    
    // Render Images
    let imagesHtml = '';
    let dotsHtml = '';
    const images = currentProductData.images || [];
    images.forEach((img, index) => {
      let resizedImg = img ? img.replace(/\.(png|jpg|jpeg|gif|webp)/i, '_313x.$1') : '';
      imagesHtml += `<div class="qv-gallery__slide"><img src="${resizedImg}" alt="${currentProductData.title}" width="313" loading="lazy"></div>`;
      dotsHtml += `<div class="qv-dot ${index === 0 ? 'active' : ''}" data-index="${index}"></div>`;
    });
    track.innerHTML = imagesHtml;
    const dotsContainer = document.getElementById('QVGalleryDots');
    if (dotsContainer) dotsContainer.innerHTML = dotsHtml;
    
    currentImageIndex = 0;
    updateGallery();

    const price = currentProductData.price || 0;
    const comparePrice = currentProductData.compare_at_price || 0;

    const savingsPercent = comparePrice > price
      ? Math.round((comparePrice - price) * 100 / comparePrice)
      : 0;

    const firstVariantId = currentProductData.variants && currentProductData.variants[0] ? currentProductData.variants[0].id : '';

    // Render Info
    info.innerHTML = `
      <h2 class="qv-title">${currentProductData.title}</h2>
      
      <div class="qv-price-row">
        <span class="qv-price-current">${safeFormatMoney(currentProductData.price)}</span>
        ${currentProductData.compare_at_price > currentProductData.price ? `<span class="qv-price-old">${safeFormatMoney(currentProductData.compare_at_price)}</span>` : ''}
      </div>
      
      ${savingsPercent > 0 ? `<div class="qv-discount-label">Discount: ${safeFormatMoney(currentProductData.compare_at_price - currentProductData.price)} (${savingsPercent}%)</div>` : ''}

      <div class="qv-buy-box">
        <div class="qv-atc-row">
          <div class="qv-qty">
            <button class="qty-btn" data-action="minus">−</button>
            <span class="qty-val">01</span>
            <button class="qty-btn" data-action="plus">+</button>
          </div>
          <button class="qv-btn-atc" data-id="${firstVariantId}">
            <span>Add To Cart</span>
            <span class="btn-loader"></span>
          </button>
        </div>

        <div class="qv-terms">
          <input type="checkbox" id="qv-terms-check">
          <label for="qv-terms-check">I agree with the <a href="/pages/terms-conditions">terms and conditions</a></label>
        </div>

        <button class="qv-btn-shop">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff"><path d="M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm7 17H5V8h2v2c0 .55.45 1 1 1s1-.45 1-1V8h4v2c0 .55.45 1 1 1s1-.45 1-1V8h2v12z"/></svg>
          <span>Buy with shop</span>
          <span class="btn-loader"></span>
        </button>
      </div>

      <div class="qv-footer-links">
        <a class="qv-footer-link qv-wishlist-add" 
          data-id="${currentProductData.id}"
          data-handle="${currentProductData.handle}"
          data-title="${currentProductData.title}"
          data-price="${safeFormatMoney(currentProductData.price)}"
          data-image="${currentProductData.featured_image}"
          data-url="${currentProductData.url}">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
          Add wishlist
        </a>
        <a class="qv-footer-link compare-toggle" data-product-handle="${currentProductData.handle}">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 3h5v5M4 20L21 3M21 16v5h-5M15 15l6 6M4 4l5 5"></path></svg>
          Add compare
        </a>
        <a class="qv-footer-link qv-share-btn">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>
          Share
        </a>
      </div>
    `;
  }

  function updateGallery() {
    if (!track) return;
    track.style.transform = `translateX(-${currentImageIndex * 100}%)`;
    const dots = document.querySelectorAll('.qv-dot');
    dots.forEach((dot, i) => dot.classList.toggle('active', i === currentImageIndex));
  }

  // Event Listeners
  document.body.addEventListener('click', function (e) {
    const qvBtn = e.target.closest('.quick-view-trigger');
    if (qvBtn) {
      openQuickView(qvBtn.dataset.productHandle, qvBtn);
    }
    
    const dot = e.target.closest('.qv-dot');
    if (dot) {
      currentImageIndex = parseInt(dot.dataset.index);
      updateGallery();
    }
  });

  closeBtn?.addEventListener('click', () => {
    modal.classList.remove('is-active');
    document.body.style.overflow = '';
  });

  overlay?.addEventListener('click', () => {
    modal.classList.remove('is-active');
    document.body.style.overflow = '';
  });

  // Touch support for gallery
  let touchStartX = 0;
  let touchEndX = 0;

  track?.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  track?.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  }, { passive: true });

  function handleSwipe() {
    const threshold = 40;
    const swipeDistance = touchStartX - touchEndX;
    const images = currentProductData?.images || [];

    if (swipeDistance > threshold) {
      // Swiped Left -> Next
      if (currentImageIndex < images.length - 1) {
        currentImageIndex++;
        updateGallery();
      }
    } else if (swipeDistance < -threshold) {
      // Swiped Right -> Prev
      if (currentImageIndex > 0) {
        currentImageIndex--;
        updateGallery();
      }
    }
  }

  modal?.querySelector('.qv-gallery__expand')?.addEventListener('click', () => {
    if (currentProductData && currentProductData.images && currentProductData.images[currentImageIndex]) {
      fullImage.src = currentProductData.images[currentImageIndex];
      fullModal.classList.add('is-active');
    }
  });

  fullClose?.addEventListener('click', () => {
    fullModal.classList.remove('is-active');
  });

  // Dynamic Logic
  info?.addEventListener('change', function(e) {
    if (e.target.id === 'qv-terms-check') {
      const atc = info.querySelector('.qv-btn-atc');
      if (e.target.checked) {
        atc.classList.add('is-ready');
      } else {
        atc.classList.remove('is-ready');
      }
    }
  });

  info?.addEventListener('click', function(e) {
    const qtyBtn = e.target.closest('.qty-btn');
    if (qtyBtn) {
      const valEl = info.querySelector('.qty-val');
      let val = parseInt(valEl.innerText);
      if (qtyBtn.dataset.action === 'plus') val++;
      else if (val > 1) val--;
      valEl.innerText = val.toString().padStart(2, '0');
    }

    const cartBtn = e.target.closest('.qv-btn-atc');
    const shopBtn = e.target.closest('.qv-btn-shop');
    
    if (cartBtn || shopBtn) {
      const termsCheck = document.getElementById('qv-terms-check');
      if (!termsCheck.checked) {
        alert('Please agree to the terms and conditions first.');
        return;
      }

      const id = cartBtn?.dataset.id || currentProductData.variants[0].id;
      const quantity = parseInt(info.querySelector('.qty-val').innerText);
      const isDirectBuy = !!shopBtn;

      const btn = cartBtn || shopBtn;
      btn.classList.add('atc-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id), quantity: quantity }] })
      }).then(res => res.json())
        .then(() => {
          if (isDirectBuy) {
            window.location.href = '/checkout';
          } else {
            modal.classList.remove('is-active');
            document.body.style.overflow = '';
            if (window.loadCart) window.loadCart();
            const cartDrawer = document.getElementById('cart-drawer');
            if (cartDrawer) cartDrawer.classList.add('active');
          }
        })
        .finally(() => {
          btn.classList.remove('atc-loading');
        });
    }

    // Share Logic
    if (e.target.closest('.qv-share-btn')) {
      if (navigator.share) {
        navigator.share({
          title: currentProductData.title,
          url: window.location.origin + currentProductData.url
        });
      } else {
        navigator.clipboard.writeText(window.location.origin + currentProductData.url);
        alert('Link copied to clipboard!');
      }
    }

    // Wishlist Logic
    const qvWishlistBtn = e.target.closest('.qv-wishlist-add');
    if (qvWishlistBtn && window.Wishlist) {
      const product = {
        id: qvWishlistBtn.dataset.id,
        handle: qvWishlistBtn.dataset.handle,
        title: qvWishlistBtn.dataset.title,
        price: qvWishlistBtn.dataset.price,
        image: qvWishlistBtn.dataset.image,
        url: qvWishlistBtn.dataset.url
      };
      window.Wishlist.add(product);
    }

    // Compare Logic (Placeholder)
    if (e.target.closest('.compare-toggle')) {
      alert('Product added to comparison list!');
    }
  });
});
